// F1 Circuits Component
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TableChart } from '../charts';

const CircuitsComponent = ({ data }) => {
  const [activeView, setActiveView] = useState('overview');
  const [selectedYear, setSelectedYear] = useState(null);

  // Transform circuit data to make names clickable
  const transformedCircuits = data?.circuits?.map(circuit => ({
    ...circuit,
    name: (
      <Link 
        to={`/f1/circuits/${circuit.circuitId}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {circuit.name}
      </Link>
    ),
    recentWinner: circuit.recentWinnerDriverId ? (
      <Link 
        to={`/f1/drivers/${circuit.recentWinnerDriverId}`}
        className="theme-primary hover:theme-accent hover:underline font-medium"
      >
        {circuit.recentWinner}
      </Link>
    ) : circuit.recentWinner
  }));
  const renderTrackTable = () => {
    if (!data || !data.circuits || data.circuits.length === 0) {
      return (
        <div className="theme-bg-secondary rounded-lg p-4">
          <p className="theme-secondary">No circuit data available</p>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        <TableChart data={transformedCircuits}
          config={{
            columns: [
              { key: 'name', label: 'Circuit' },
              { key: 'country', label: 'Country' },
              { key: 'location', label: 'Location' },
              { key: 'recentWinner', label: 'Recent Winner' },
              { key: 'raceCount', label: 'Total Races' }
            ],
            sortable: true,
            searchable: true,
            sortBy: 'raceCount',
            sortDirection: 'desc',
            pagination: true,
            pageSize: 10,
            showHeader: true,
            rowHeight: 40,
            headerHeight: 40,
            showFooter: true,
            footerHeight: 40
          }}
        />
      </div>
    );
  };

  return (
    <>
      <div className="mt-8">
        {renderTrackTable()}
      </div>

    </>
  );
};

export const circuitsConfig = {
  title: 'F1 Circuits',
  subtitle: 'Circuit information, track characteristics, and race venue data from Formula 1',
  summary: ['Circuit details', 'Track statistics', 'Race venue history'],
  stats: [
    { 
      value: (data) => data?.circuits?.length || 0, 
      label: 'Total Circuits',
    },
    { 
      value: (data) => new Set(data?.circuits?.map(circuit => circuit.country)).size || 0, 
      label: 'Countries',
    },
    { 
      value: (data) => (data?.circuits?.reduce((acc, circuit) => acc + circuit.length, 0) / data?.circuits?.length || 0).toFixed(2) + 'km', 
      label: 'Avg. Track Length',
    },
    { 
      value: '60+', 
      label: 'Laps per Race',
    }
  ],
  component: CircuitsComponent
};

export default CircuitsComponent;
